module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="row integrations-setup salesforce-commerce-quick-view">\n    <section class="col-xs-4">\n        <h4>Salesforce Commerce Cloud QuickView Action</h4>\n        <p class="intro">Creator\'s Salesforce Commerce Cloud QuickView Action makes it a lot easier to call your own Product\n                         QuickViews for different Widgets in your Creator Experiences.</p>\n        ';
 if (!isSalesforceCommerceEnabled && config.salesEmail) { ;
__p += '\n        <p>Get the Add-on by contacting <a href="mailto:' +
__e( config.salesEmail ) +
'">' +
__e( config.salesEmail ) +
'</a></p>\n        ';
 } ;
__p += '\n        <div class="illustration salesforce-commerce-logo"></div>\n    </section>\n    ';
 if (isSalesforceCommerceEnabled) { ;
__p += '\n    <section class="col-xs-8">\n        <section class="row">\n            <section class="col-xs-6">\n                <h4>How to use the Action</h4>\n                <p>Your Salesforce Commerce Cloud QuickView Action is available in the Action Menu inside the Editor.\n                    Simply copy your Product ID\'s into the Action field to connect your Product Database\n                    with your published Creator Experiences.\n                </p>\n            </section>\n        </section>\n        <section class="row">\n            <section class="col-xs-6">\n                <div class="illustration salesforce-commerce-action-1"></div>\n            </section>\n            <section class="col-xs-6">\n                <div class="illustration salesforce-commerce-action-2"></div>\n            </section>\n        </section>\n    </section>\n    ';
 } ;
__p += '\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/settings/view/SalesforceCommerceQuickViewSettings.tpl
// module id = 3059
// module chunks = 0